function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M310.819,415.086c-0.687-4.084-4.551-6.841-8.64-6.152c-4.084,0.687-6.839,4.555-6.152,8.64 c0.374,2.223,0.563,4.503,0.563,6.777c0,12.281-5.474,23.772-15.017,31.527c-9.542,7.753-22.093,10.721-34.428,8.143 c-15.404-3.22-27.826-15.776-30.908-31.246c-2.96-14.855,2.026-29.509,13.338-39.197c11.366-9.735,17.885-23.278,17.885-37.155 V199.377h17.064v157.085c0,14.273,6.265,27.59,17.19,36.534c1.394,1.142,3.076,1.697,4.747,1.697c2.171,0,4.325-0.938,5.807-2.749 c2.625-3.205,2.154-7.93-1.051-10.554c-7.43-6.084-11.692-15.17-11.692-24.929V103.696c0-4.142-3.358-7.5-7.5-7.5 s-7.5,3.358-7.5,7.5v80.68H247.46V55.599c0-4.705,3.828-8.532,8.532-8.532c4.704,0,8.532,3.828,8.532,8.532v16.029 c0,4.142,3.358,7.5,7.5,7.5s7.5-3.358,7.5-7.5V55.599c0-12.976-10.557-23.533-23.533-23.533s-23.533,10.557-23.533,23.533v300.825 c0,9.49-4.608,18.881-12.642,25.762c-15.487,13.265-22.326,33.273-18.292,53.522c4.242,21.285,21.341,38.564,42.55,42.997 c3.944,0.825,7.905,1.23,11.83,1.23c12.769,0,25.134-4.294,35.126-12.414c13.064-10.616,20.559-26.351,20.559-43.168 C311.591,421.245,311.332,418.128,310.819,415.086z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M314.093,358.825c-1.59-1.409-2.502-3.605-2.502-6.025v-33.177h8.532c4.142,0,7.5-3.358,7.5-7.5s-3.358-7.5-7.5-7.5h-8.532 V279.54h16.548c4.142,0,7.5-3.358,7.5-7.5s-3.358-7.5-7.5-7.5h-16.548v-25.082h8.532c4.142,0,7.5-3.358,7.5-7.5s-3.358-7.5-7.5-7.5 h-8.532v-25.082h16.548c4.142,0,7.5-3.358,7.5-7.5s-3.358-7.5-7.5-7.5h-16.548v-25.082h8.532c4.142,0,7.5-3.358,7.5-7.5 s-3.358-7.5-7.5-7.5h-8.532v-25.082h16.548c4.142,0,7.5-3.358,7.5-7.5s-3.358-7.5-7.5-7.5h-16.548v-25.08h8.532 c4.142,0,7.5-3.358,7.5-7.5s-3.358-7.5-7.5-7.5h-8.532v-8.532C311.591,24.941,286.65,0,255.992,0s-55.599,24.941-55.599,55.599 v297.193c0,2.427-0.895,4.611-2.456,5.992c-22.059,19.521-32.805,48.678-28.749,77.998c5.374,38.837,37.586,70.234,76.593,74.653 c3.338,0.378,6.674,0.565,9.998,0.565c21.552,0,42.471-7.855,58.585-22.246c18.615-16.624,29.29-40.462,29.29-65.403 C343.656,399.358,332.881,375.474,314.093,358.825z M304.374,478.567c-15.642,13.969-35.849,20.347-56.902,17.964 c-32.301-3.66-58.975-29.653-63.423-61.805c-3.367-24.335,5.542-48.524,23.831-64.709c4.776-4.226,7.515-10.505,7.515-17.227V55.599 c0-22.386,18.212-40.598,40.598-40.598s40.598,18.212,40.598,40.598v297.201c0,6.71,2.753,12.998,7.554,17.253 c15.577,13.804,24.512,33.596,24.512,54.3C328.656,445.024,319.806,464.785,304.374,478.567z"
});

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var _ref17 = /*#__PURE__*/React.createElement("g", null);

var _ref18 = /*#__PURE__*/React.createElement("g", null);

var SvgTemperature = function SvgTemperature(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E4EAF8"
    },
    d: "M304.09,352.798v-297.2c0-26.564-21.535-48.098-48.098-48.098l0,0 c-26.564,0-48.098,21.535-48.098,48.098v297.193c0,4.39-1.698,8.7-4.985,11.609c-19.184,16.977-30.221,42.934-26.289,71.354 c4.934,35.663,34.234,64.176,70.008,68.229c48.463,5.491,89.529-32.275,89.529-79.632c0-23.867-10.478-45.238-27.038-59.913 C305.819,361.515,304.09,357.206,304.09,352.798z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D5DCED"
    },
    d: "M272.025,364.488V56.456c0-7.986-5.457-15.388-13.339-16.67 c-10.044-1.634-18.726,6.075-18.726,15.813V364.47c0,8.15-4.249,15.564-10.989,20.146c-15.199,10.332-24.177,29.113-20.089,49.625 c3.659,18.364,18.401,33.291,36.729,37.122c31.099,6.501,58.481-17.057,58.481-47.011c0-16.702-8.528-31.384-21.459-39.994 C275.987,379.933,272.025,372.47,272.025,364.488z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF507D"
    },
    d: "M239.959,191.877v172.592c0,8.15-4.249,15.564-10.989,20.146 c-15.2,10.332-24.177,29.113-20.089,49.626c3.659,18.364,18.401,33.291,36.729,37.122c31.099,6.501,58.48-17.057,58.48-47.011 c0-16.702-8.528-31.384-21.459-39.994c-6.644-4.424-10.606-11.887-10.606-19.87V191.877H239.959z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D23C69"
    },
    d: "M274.615,448.488c-26.564,0-48.098-21.535-48.098-48.098c0-5.652,1.025-11.051,2.816-16.089 c-0.132,0.093-0.228,0.222-0.363,0.313c-15.2,10.332-24.177,29.113-20.089,49.626c3.659,18.364,18.401,33.291,36.729,37.122 c25.271,5.283,48.086-9.283,55.75-31C293.712,445.49,284.516,448.488,274.615,448.488z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FF789B"
    },
    cx: 268.019,
    cy: 412.322,
    r: 12.02
  }), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTemperature, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/temperature.cccbe672.svg";
export { ForwardRef as ReactComponent };